// extracted by mini-css-extract-plugin
export default {"base":"_404-module--base--c9114"};